export default __webpack_public_path__ + "static/media/cleanproExpressLogo.33073d7c.png";